import React, { PropTypes, Component } from "react";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, FormGroup, FormText, Input, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, InputGroupAddon} from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import DatePicker from 'react-datepicker';
import DataWrapper from "../../../principal/containers/DataWrapper";
import Select from "react-select";
import {createSelectOptions} from "../../../../utils/formatar";
import {getMotivoContratacaoById} from "../../../../utils/enums";
import {Validacao} from "../../../comum/components/Validacao";
import _ from 'lodash';
import ParametrosGeraisStore from "../../../administracao/stores/ParametrosGeraisStore";
import {Redirect} from "react-router-dom";
import {FormWithActions} from "../../../comum/components/FormWithActions";
import {DetalhamentoSolicitante} from "../../comum/components/DetalhamentoSolicitante";
import {DetalhamentoEmpregadosSubstituidos} from "../../comum/components/DetalhamentoEmpregadosSubstituidos";
import {DetalhamentoIndicacoes} from "../../comum/components/DetalhamentoIndicacoes";
import {DetalhamentoContato} from "../../comum/components/DetalhamentoContato";
import {DetalhamentoCargo} from "../../comum/components/DetalhamentoCargo";
import {DetalhamentoJustificativaExcecao} from "../../comum/components/DetalhamentoJustificativaExcecao";
import {DetalhamentoDebito} from "../../comum/components/DetalhamentoDebito";
import {DetalhamentoLocais} from "../../comum/components/DetalhamentoLocais";
import {DetalhamentoJustificativa} from "../../comum/components/DetalhamentoJustificativa";
import {DetalhamentoPrazos} from "../../comum/components/DetalhamentoPrazos";
import {DetalhamentoPerfil} from "../../comum/components/DetalhamentoPerfil";
import {DetalhamentoCPFDiferente} from "../../solicitacao_ett/components/DetalhamentoCPFDiferente";
import {DetalhamentoDadosMOT} from "../../solicitacao_ett/components/DetalhamentoDadosMOT";
import {DetalhamentoSalarioDiferente} from "../../solicitacao_ett/components/DetalhamentoSalarioDiferente";
import {DetalhamentoAlterarDataInicio} from "../../solicitacao_ett/components/DetalhamentoAlterarDataInicio";
import {DetalhamentoContratosAnterioresEValidacoes} from "../../comum/components/DetalhamentoContratosAnterioresEValidacoes";
import {DetalhamentoHistorico} from "../../comum/components/DetalhamentoHistorico";
import {DadosTerminoAntecipado} from "../../solicitacao_termino_antecipado/components/DadosTerminoAntecipado";
import {DadosMOTSubstituido} from "../components/DadosMOTSubstituido";
import {DadosMOTSubstituidoForm} from "../components/DadosMOTSubstituidoForm";
import {DetalhamentoProrrogacoesAnteriores} from "../../comum/components/DetalhamentoProrrogacoesAnteriores";
import {LoadingPanel} from "../../../comum/components/LoadingPanel";
import AndamentoSubstituicaoStore from "../stores/AndamentoSubstituicaoStore";
import EmpregadoService from "../../../../services/EmpregadoService";

@inject("store")
@DataWrapper
@observer
export class DetalhesAndamentoSubstituicao extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;
        this.formStore = this.props.store.formStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;


        this.parametrosGeraisStore = new ParametrosGeraisStore();

        this.controller = new AndamentoSubstituicaoStore(this.parametrosGeraisStore, this.loginStore, this.tituloPaginaStore, this.validacaoStore, this.modalStore, this.loadingPanelStore);

        this.observacoesModal = this.observacoesModal.bind(this);
        this.state.listAprovadores= [];
        this.state.empregadoService= new EmpregadoService();
    }

    componentWillMount(){
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Detalhamento substituição");

        const solicitacaoId = _.get(this.props, "match.params.solicitacaoId");
        const solicitacaoEttId = _.get(this.props, "match.params.solicitacaoEttId");
        const substituicaoId = _.get(this.props, "match.params.substituicaoId");
        this.controller.carregarLista({solicitacaoId: solicitacaoId, solicitacaoEttId: solicitacaoEttId, substituicaoId: substituicaoId});
    }

    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
            PropTypes.object,
        ])
    };

    observacoesModal() {
        const aprovadoresExtraForm = [];

        const razaoAtrasoOptions = createSelectOptions(this.controller.motivosAtraso, "nome", "nome");

        if(this.controller.solicitacao.matriculaAprovadoresExtra) {
            for(let i=0; i<this.controller.solicitacao.matriculaAprovadoresExtra.length; i++) {
                aprovadoresExtraForm.push(<Row key={i}>
                    <Col xs={12}>
                        {this.controller.solicitacao.matriculaAprovadoresExtra[i] !== null &&
                        <FormGroup>
                            <div className="multiple-selects">
                                <Select className="multiple-selects-input"
                                        options={this.state.listAprovadores}
                                        value={this.controller.solicitacao.matriculaAprovadoresExtra[i]}
                                        onChange={(value) => { this.controller.setMatriculaAprovadoresExtra(value, i) }}
                                        multi={false}
                                        placeholder="Selecione..."
                                        noResultsText="Nenhum resultado encontrado"
                                />
                                <div className="multiple-selects-buttons">
                                    {(i > this.controller.posicaoPrimeiroAprovadorExtra || this.controller.quantidadeAprovadoresExtraMostrados > 1) &&
                                        <a onClick={() => this.controller.removerAprovadorExtra(i)} title="Remover"><FontAwesome name="minus-circle"/></a>
                                    }
                                    <a onClick={() => this.controller.adicionarAprovadorExtra(i)}
                                       title="Adicionar"><FontAwesome name="plus-circle"/></a>
                                </div>
                            </div>
                        </FormGroup>
                        }
                    </Col>
                </Row>)
            }
        }

        return (
            <div>
                {_.get(this.modalStore, "exibirModal.tipo") === 'aprovar' && this.controller.nomeTarefa === "HT_AvaliacaoSolicitacaoContratacao" && this.controller.nomeFluxo === "GloboMOTSolicitacaoMOT" &&
                <div>
                    {this.controller.quantidadeAprovadoresExtraMostrados > 0 && <Label>Aprovadores extra</Label>}
                    {aprovadoresExtraForm}
                    <FormGroup>
                        <Validacao id="aprovadoresUnicos" valor={this.controller.apenasMatriculaAprovadoresExtraValidos} tipo={["isArrayUnique"]}/>
                    </FormGroup>
                </div>
                }
                {this.controller.nomeFluxo === "GloboMOTSolicitacaoEtt" && this.controller.nomeTarefa === "HT_ConfirmarContratacaoETT" &&
                    <div>
                        {this.controller.confirmarAlocacaoETT.informarDataInicioDiferente &&
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <Label>Razão de alteração de início</Label>
                                    <Select value={this.controller.confirmarAlocacaoETT.razaoAtraso}
                                            options={razaoAtrasoOptions}
                                            onChange={(value) => this.controller.setRazaoAtraso(value)}
                                            noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                            multi={false} />
                                    <Validacao id="razaoAtraso" valor={this.controller.confirmarAlocacaoETT.razaoAtraso}
                                               tipo={["isRequired"]}/>
                                </FormGroup>
                            </Col>
                        </Row>
                        }
                        <Row>
                            <Col xs={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={this.controller.confirmacaoModalEtt} onChange={() => this.controller.toggleConfirmacaoModalEtt()}/>{' '}
                                        Confirmo que o recurso está apto para iniciar o trabalho na data prevista
                                    </Label>
                                    <Validacao id="confirmacaoModalEtt" valor={this.controller.confirmacaoModalEtt} tipo={["isBooleanRequired"]}/>
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                }
                <FormGroup>
                    {(_.get(this.modalStore, "exibirModal.tipo") === 'desistir' || _.get(this.modalStore, "exibirModal.tipo") === 'rejeitar'
                        || _.get(this.modalStore, "exibirModal.tipo") === 'demandarAjustes' || _.get(this.modalStore, "exibirModal.tipo") === 'cancelar') ? (
                        <Label>Observações <sup>*</sup></Label>
                    ):(
                        <Label>Observações</Label>
                    )}
                    <Input type="textarea" maxLength={1024} value={this.controller.observacoes} onChange={(event) => this.controller.setObservacoes(event.target.value)}  />
                    {(_.get(this.modalStore, "exibirModal.tipo") === 'desistir' || _.get(this.modalStore, "exibirModal.tipo") === 'rejeitar' || _.get(this.modalStore, "exibirModal.tipo") === 'demandarAjustes' || _.get(this.modalStore, "exibirModal.tipo") === 'cancelar') && <Validacao id="observacoes" valor={this.controller.observacoes} tipo={["isRequired"]} />}
                </FormGroup>
            </div>
        )
    }

    render() {
        const desabilitarValidacao = this.validacaoStore.desabilitarValidacao

        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel panel-sm">
                            <Form className="panel-form">
                                <FormWithActions controller={this.controller} taskId={_.get(this.props, "match.params.taskIdBpm")} solicitacaoExcecao={this.controller.isSolicitacaoExcecao}
                                             tarefa={this.controller.nomeTarefa} fluxo={this.controller.nomeFluxo} possiveisAcoes={this.controller.possiveisAcoes}
                                             observacoesModal={() => this.observacoesModal()}
                                             error={this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm}>
                                    {this.controller.exibeJustificativaExcecao &&
                                        <DetalhamentoJustificativaExcecao />
                                    }
                                    <DetalhamentoSolicitante />
                                    <DetalhamentoContato desabilitarValidacao={desabilitarValidacao} />
                                    <DetalhamentoLocais />
                                    {this.controller.exibeDebito &&
                                        <DetalhamentoDebito />
                                    }
                                    <DetalhamentoJustificativa />
                                    <DetalhamentoEmpregadosSubstituidos />
                                    <DetalhamentoPrazos />
                                    {this.controller.exibeDetalhamentoTerminoAntecipado &&
                                    <DadosTerminoAntecipado />
                                    }
                                    <DetalhamentoCargo />
                                    <DetalhamentoPerfil />
                                    {this.controller.exibeIndicacoes &&
                                        <DetalhamentoIndicacoes />
                                    }
                                    {this.controller.exibeDetalhamentoCPFDiferente &&
                                        <DetalhamentoCPFDiferente desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    {this.controller.exibeDetalhamentoDadosMOT &&
                                        <DetalhamentoDadosMOT desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    {this.controller.exibeDetalhamentoSalarioDiferente &&
                                        <DetalhamentoSalarioDiferente desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    {this.controller.exibeDetalhamentoAlterarDataInicio &&
                                        <DetalhamentoAlterarDataInicio desabilitarValidacao={desabilitarValidacao}/>
                                    }
                                    { this.controller.exibeContratosAnterioresEValidacoes &&
                                        <DetalhamentoContratosAnterioresEValidacoes/>
                                    }
                                    {this.controller.exibeDetalhamentoSubstituicao &&
                                        <DadosMOTSubstituido />
                                    }
                                    <DetalhamentoProrrogacoesAnteriores titulo={"Prorrogações realizadas"} textoNenhumResultado={"Nenhuma prorrogação realizada"} />
                                    {this.controller.exibeDetalhamentoHistorico &&
                                        <DetalhamentoHistorico />
                                    }
                                </FormWithActions>
                            </Form>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        )
    }
}